
import { LucideIcon, Home, Search, Plus, Settings, User2, MessageCircle, SparklesIcon, BeakerIcon, Crown, BookOpen, Trophy } from "lucide-react";

export interface NavItem {
  title: string;
  href: string;
  icon?: LucideIcon;
  requiresAuth?: boolean;
  adminOnly?: boolean;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
}

export interface NavSection {
  title?: string;
  items: NavItem[];
}

// Primary navigation items shown in the main navbar
export const mainNavItems: NavItem[] = [
  {
    title: "Home",
    href: "/",
    icon: Home,
  },
  {
    title: "Explore",
    href: "/explore",
    icon: Search,
  },
  {
    title: "Resources",
    href: "/blog",
    icon: BookOpen,
  },
  {
    title: "Leaderboard",
    href: "/leaderboard",
    icon: Trophy,
  },
  {
    title: "Submit",
    href: "/create-prompt",
    icon: Plus,
    requiresAuth: true,
  },
];

// User-related navigation items
export const userNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: Home,
    requiresAuth: true,
  },
  {
    title: "Profile",
    href: "/profile",
    icon: User2,
    requiresAuth: true,
  },
  {
    title: "PromptLab",
    href: "/prompt-lab",
    icon: BeakerIcon,
    requiresAuth: true,
  },
];

// Admin-specific navigation items
export const adminNavItems: NavItem[] = [
  {
    title: "Admin Dashboard",
    href: "/admin",
    icon: Settings,
    requiresAuth: true,
    adminOnly: true,
  },
  {
    title: "Product Copilot",
    href: "/product-copilot",
    icon: SparklesIcon,
    requiresAuth: true,
    adminOnly: true,
  },
];

// Function to get the correct user profile URL
export const getUserProfileUrl = (userId: string | undefined): string => {
  if (!userId) return "/profile";
  return `/profile/${userId}`;
};
